import React, { useState, useEffect } from 'react';
import { post } from "../services/http-service";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import storageService from 'src/services/storage-service';
import Alert from '@mui/material/Alert';


const FIELDS = [
  { key: 'company', label: 'Kommun/företag', required: true, value: '' },
  { key: 'email', label: 'E-postadress', required: true, value: '' },
  { key: 'unit', label: 'Förvaltning/enhet', value: '' },
  { key: 'name', label: 'Namn', value: '' },
  { key: 'phone', label: 'Telefon', value: '' },
  { key: 'users', label: 'Antal användare', value: '' },
  { key: 'orgLicense', label: 'Förvaltningslicens', checkbox: true, value: false },
  { key: 'freeTrial', label: 'Prova gratis', checkbox: true, value: false }
];

function OfferDialog({ open, onClose, title }) {

  const [errorMessage, setErrorMessage] = useState('');
  const [fields, setFields] = useState(FIELDS);

  useEffect(() => {
    setErrorMessage('');
    const user = storageService.load();
    FIELDS[0].value = user.organizationName;
    FIELDS[1].value = user.email.indexOf("@") > 0 ? user.email : '';
    FIELDS[3].value = user.displayName;

  }, [open])

  const changeField = (index, value) => {

    const newFields = [...fields];
    newFields[index].value = value;
    setFields(newFields);
  }

  const onSubmit = async () => {

    for (let i = 0; i < 2; i++) {
      if (!fields[i].value) {
        return setErrorMessage(`${FIELDS[i].label} är obligatoriskt`);
      }
    }

    const form = new FormData();
    form.append('database', title);

    fields.forEach(f => {
      form.append(f.key, f.value);
    });

    await post('/quote/request', form, true);

    setErrorMessage('');
    onClose(true);
  }

  return (
    <Dialog
      open={open}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">Offert för {title}</DialogTitle>
      <Box width={600} >
        <DialogContent dividers>

          {errorMessage && (
            <Box mb={4}>
              <Alert variant="filled" severity="error">
                {errorMessage}
              </Alert>
            </Box>
          )}

          <FormGroup>
            {fields.map((field, index) =>
              <Box key={index}>
                {!field.checkbox && <TextField
                  
                  onChange={(e) => changeField(index, e.target.value)}
                  value={field.value}
                  margin="normal"
                  required={field.required}
                  fullWidth
                  label={field.label}
                />}
                {field.checkbox && <FormControlLabel key={'B'+index} control={<Checkbox checked={field.value} onChange={(event) => changeField(index, event.target.checked)} />} label={field.label} />}
              </Box>

            )}

          </FormGroup>

        </DialogContent>
      </Box>
      <DialogActions>
        <Button variant="contained" onClick={onSubmit}>Skicka</Button>
        <Button onClick={onClose}>Avbryt</Button>
      </DialogActions>
    </Dialog >
  )

}

OfferDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
};

export default OfferDialog;